module.exports = __webpack_public_path__ + "fonts/u2f_38x38.ddb01326984e01d7fa8c07f20f844f6d.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/u2f_38x38.png
// module id = 793
// module chunks = 9